import markdown from '@wcj/markdown-to-html';

import { Container } from '@/atoms';
import { CardBlog, SliderCard } from '@/molecules';
import { BlogArticle as BlogArticleTemplate } from '@/templates';

import { config } from '@/config';
import { getBlogList, getBlogPost, getPage } from '@/graphql/queries';
import { routes } from '@/lib';
import { getImageWithFallBackWithOutAlt, getRealUrl } from '@/utils';

const BlogArticle = ({ page: { post } }: any) => (
  <>
    <BlogArticleTemplate
      title={post.Titulo}
      date={post.Publicado}
      image={getImageWithFallBackWithOutAlt(
        getRealUrl(post?.post?.ImagenPrincipal?.url),
        config.fallbackImage,
      )}
      socialMediaTitle="Comparte"
      articleText={post.post.Contenido}
    />

    <Container wrapper>
      <h4 className="text-headline text-headline-h4 mb-4 md:mb-6">
        Otros artículos que podrían interesarte
      </h4>

      <SliderCard
        perPage={3}
        breakpoints={{
          1024: {
            perPage: 3,
          },
          768: {
            padding: 38,
            perPage: 2,
            gap: 16,
          },
          500: {
            padding: 30,
            perPage: 1,
          },
        }}
      >
        {post.post.blog_posts.map((itm: any, index: number) => (
          <CardBlog
            key={`card-blog-${index}`}
            image={{
              alt: itm.post?.ImagenPrincipal?.alternativeText || itm.Titulo,
              src: getImageWithFallBackWithOutAlt(
                getRealUrl(itm.post?.ImagenPrincipal?.url),
                config.fallbackImage,
              ),
            }}
            title={itm.Titulo}
            description={itm.Descripcion}
            tag={itm.post.category.category}
            link={{
              label: 'Saber más',
              href: itm.slug,
            }}
            className="h-full"
          />
        ))}
      </SliderCard>
    </Container>
  </>
);

export const getStaticProps = async ({ params }: any) => {
  const { blogPosts } = await getBlogPost(routes.blog.post(params.slug));

  const { menus, preFooter } = await getPage('/blog');
  const post = blogPosts?.[0];

  post.post.Contenido = markdown(post.post.Contenido).toString();

  return {
    props: {
      page: {
        attributes: post || null,
        theme: 'light',
        langcode: {
          id: 'es',
        },
        post,
        menu: menus || [],
        preFooter: preFooter || null,
      },
    },
    revalidate: process.env.NEXT_PUBLIC_REVALIDATE
      ? parseInt(process.env.NEXT_PUBLIC_REVALIDATE)
      : 1000,
    notFound: !post,
  };
};

export async function getStaticPaths() {
  const { blogPosts } = await getBlogList();

  return {
    paths: blogPosts.map((itm: any) => itm.slug),
    fallback: 'blocking',
  };
}

export default BlogArticle;
